import { EstimateEndStateRoutes } from "pages/EstimateAnalysis/types";

import { Locale } from "types/locale";

import { ClientConfig } from "./types";

export const BASE_CLIENT_CONFIG: ClientConfig = {
  clientId: "tractable",
  displayName: "Tractable",
  locale: Locale.English_GB,
  disableGalleryUpload: true,
  detectDuplicatePicture: true,
  enableDelightedFeedback: false,
  showFeedbackCompleted: true,
  enablePayeeJourney: true,
  logo: "https://public.prod-euce1.assets.tractable.io/car-owner-app/logos/tractable.svg",
  theme: {
    colours: {
      primary: "#3B25C4",
    },
    buttons: { borderRadius: 4 },
    font: {
      url: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;600&display=swap",
      family: "'IBM Plex Sans', sans-serif",
    },
  },
  welcome: {
    disabled: false,
    termsLink: "//tractable.ai",
  },
  onboarding: {
    checklistItems: ["yourVehicle", "vehicleKeys"],
  },
  vehicleCondition: {
    disabled: false,
    showMileage: true,
    showMileagePhoto: false,
    questions: ["haveAirbagsDeployed", "isVehicleDrivable"],
  },
  damagePhotos: {
    photoTips: ["flashOn", "uploadFromGallery"],
  },
  damageReview: {
    disabled: false,
  },
  estimate: {
    endStateRoutes: {
      repairable: EstimateEndStateRoutes.RepairableRoute,
    },
    repairable: {
      showTotalPrice: true,
      includeTaxInTotal: true,
      showBreakdown: true,
      showDamagedPartList: true,
      showHowIsItCalculatedHelper: true,
      withSpeedyPayment: true,
      withNegotiation: false,
      showInternalDamageWarning: false,
      showDamagedPartListCosts: false
    },
  }
};
